<template>
  <ul class="some-search-letters">
    <template v-if="language === 'en'">
      <li v-for="(item,idx) in enletter" :key="idx">
        <label>
          <input :name="name" :checked="item.label === initLetter" :value="item.label" type="radio" @click="update(item)">
          <span :class="{active: item.label === initLetter, disabled: !item.status}">{{item.label}}</span>
        </label>
      </li>
    </template>
    <template v-else-if="language === 'cn'">
      <li v-for="(item,idx) in cnletter" :key="idx">
        <label>
          <input :name="name" :checked="item.label === initLetter" :value="item.label" type="radio" @click="update(item)">
          <span :class="{active: item.label === initLetter, disabled: !item.status}">{{item.label}}</span>
        </label>
      </li>
    </template>
    <template v-else>
      <div class="group-container" v-for="(groupItem, index) in jpLetter" :key="index">
        <div v-for="item in groupItem" :key="item.label" :class="['item', item.status ? '' : 'disabled', item.label === initLetter ? 'active' : '']" @click="update(item)">{{ item.label }}</div>
      </div>
    </template>
  </ul>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    initLetter: {
      type: String,
      default: 'A'
    }
  },
  data () {
    return {
      enletter: [
        {
          label: 'A',
          status: true
        },
        {
          label: 'B',
          status: true
        },
        {
          label: 'C',
          status: true
        },
        {
          label: 'D',
          status: true
        },
        {
          label: 'E',
          status: true
        },
        {
          label: 'F',
          status: true
        },
        {
          label: 'G',
          status: true
        },
        {
          label: 'H',
          status: true
        },
        {
          label: 'I',
          status: false
        },
        {
          label: 'J',
          status: false
        },
        {
          label: 'K',
          status: false
        },
        {
          label: 'L',
          status: true
        },
        {
          label: 'M',
          status: true
        },
        {
          label: 'N',
          status: true
        },
        {
          label: 'O',
          status: true
        },
        {
          label: 'P',
          status: true
        },
        {
          label: 'Q',
          status: true
        },
        {
          label: 'R',
          status: true
        },
        {
          label: 'S',
          status: true
        },
        {
          label: 'T',
          status: true
        },
        {
          label: 'U',
          status: false
        },
        {
          label: 'V',
          status: true
        },
        {
          label: 'W',
          status: true
        },
        {
          label: 'X',
          status: false
        },
        {
          label: 'Y',
          status: false
        },
        {
          label: 'Z',
          status: false
        }
      ],
      cnletter: [
        {
          label: 'A',
          status: false
        },
        {
          label: 'B',
          status: true
        },
        {
          label: 'C',
          status: true
        },
        {
          label: 'D',
          status: true
        },
        {
          label: 'E',
          status: true
        },
        {
          label: 'F',
          status: true
        },
        {
          label: 'G',
          status: true
        },
        {
          label: 'H',
          status: true
        },
        {
          label: 'I',
          status: false
        },
        {
          label: 'J',
          status: true
        },
        {
          label: 'K',
          status: true
        },
        {
          label: 'L',
          status: true
        },
        {
          label: 'M',
          status: true
        },
        {
          label: 'N',
          status: true
        },
        {
          label: 'O',
          status: false
        },
        {
          label: 'P',
          status: true
        },
        {
          label: 'Q',
          status: true
        },
        {
          label: 'R',
          status: true
        },
        {
          label: 'S',
          status: true
        },
        {
          label: 'T',
          status: true
        },
        {
          label: 'U',
          status: false
        },
        {
          label: 'V',
          status: false
        },
        {
          label: 'W',
          status: true
        },
        {
          label: 'X',
          status: true
        },
        {
          label: 'Y',
          status: true
        },
        {
          label: 'Z',
          status: true
        }
      ],
      jpLetter: [
        [
          {
            label: 'あ',
            status: true
          },
          {
            label: 'い',
            status: true
          },
          {
            label: 'う',
            status: true
          },
          {
            label: 'え',
            status: true
          },
          {
            label: 'お',
            status: true
          }
        ],
        [
          {
            label: 'か',
            status: true
          },
          {
            label: 'き',
            status: true
          },
          {
            label: 'く',
            status: true
          },
          {
            label: 'け',
            status: true
          },
          {
            label: 'こ',
            status: true
          }
        ],
        [
          {
            label: 'さ',
            status: true
          },
          {
            label: 'し',
            status: true
          },
          {
            label: 'す',
            status: true
          },
          {
            label: 'せ',
            status: true
          },
          {
            label: 'そ',
            status: true
          }
        ],
        [
          {
            label: 'た',
            status: true
          },
          {
            label: 'ち',
            status: true
          },
          {
            label: 'つ',
            status: true
          },
          {
            label: 'て',
            status: true
          },
          {
            label: 'と',
            status: true
          }
        ],
        [
          {
            label: 'な',
            status: true
          },
          {
            label: 'に',
            status: true
          },
          {
            label: 'ぬ',
            status: true
          },
          {
            label: 'ね',
            status: true
          },
          {
            label: 'の',
            status: true
          }
        ],
        [
          {
            label: 'は',
            status: true
          },
          {
            label: 'ひ',
            status: true
          },
          {
            label: 'ふ',
            status: true
          },
          {
            label: 'へ',
            status: true
          },
          {
            label: 'ほ',
            status: true
          }
        ],
        [
          {
            label: 'ま',
            status: true
          },
          {
            label: 'み',
            status: true
          },
          {
            label: 'む',
            status: true
          },
          {
            label: 'め',
            status: true
          },
          {
            label: 'も',
            status: true
          }
        ],
        [
          {
            label: 'や',
            status: true
          },
          {
            label: 'ゆ',
            status: false
          },
          {
            label: 'よ',
            status: false
          }
        ],
        [
          {
            label: 'ら',
            status: true
          },
          {
            label: 'り',
            status: true
          },
          {
            label: 'る',
            status: false
          },
          {
            label: 'れ',
            status: true
          },
          {
            label: 'ろ',
            status: true
          }
        ],
        [
          {
            label: 'わ',
            status: false
          }
        ]
      ],
      language: this.$i18n.locale
    }
  },
  methods: {
    update (item) {
      if (!item.status) return
      this.$emit('update', item.label)
    }
  },
  mounted () {
    let defaultValue
    if (this.language === 'en') {
      defaultValue = 'A'
    } else if (this.language === 'cn') {
      defaultValue = 'B'
    } else {
      defaultValue = 'あ'
    }
    this.update(defaultValue)
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

input
  position absolute
  clip rect(0,0,0,0)

ul
  font-size 0px
  li
    display inline-block
    label
      display: inline-block;
      span
        display inline-block

.some-search-letters
  margin-bottom: 14px;
  & li label span
    font1()
    font-size 12px
    width 31px
    text-align center
    color #232323
    line-height 32px
    cursor pointer
    &.active{
      color $themeColor3
    }
    &.disabled{
      cursor not-allowed
      color rgba(0,0,0,0.8)
      opacity 0.3
    }
.group-container
  display inline-block
  background #D3DFEB
  margin-right 20px
  height 32px
  line-height 32px
  border-radius 2px
  padding 0 10px
  margin-bottom 8px
  .item
    display inline-block
    width 24px
    height 24px
    line-height 24px
    text-align center
    font-size 14px
    box-sizing border-box
    margin-right 6px
    margin-top 4px
    cursor pointer
    color rgba(0,0,0,0.8)
    border-radius 2px
    &:last-child {
      margin-right 0
    }
  .disabled
    opacity 0.3
    cursor not-allowed
  .active
    color #007F42
    border 1px solid #007F42
</style>



// WEBPACK FOOTER //
// src/components/base/letterSearch/Letter.vue